import { useI18n } from "./integrations/formatjs/I18nContext";
const useI18nMessage = ({ domain, id, prefix = "", defaultMessage, values, }) => {
    const intl = useI18n({ domain });
    return intl.formatMessage({
        id: `${prefix}${id}`,
        defaultMessage: defaultMessage || `${prefix}${id}`,
    }, values);
};
export { useI18nMessage };
